import { Country, Region, SubRegion, Variety } from '@ministry-of-wine/shared';
import { apiClient } from './api';

interface ReferenceOption {
  id: number;
  name: string;
}

export const referenceDataService = {
  getCountries: () => apiClient.get<Country[]>('/reference/countries'),
  getRegions: () => apiClient.get<Region[]>('/reference/regions'),
  getSubRegions: () => apiClient.get<SubRegion[]>('/reference/sub-regions'),
  getVarieties: () => apiClient.get<Variety[]>('/reference/varieties'),
  getBottleTypes: () => apiClient.get<ReferenceOption[]>('/reference/bottle-types'),
  getClosureTypes: () => apiClient.get<ReferenceOption[]>('/reference/closure-types'),
  getPackingTypes: () => apiClient.get<ReferenceOption[]>('/reference/packing-types'),
};
